import { createAction, handleActions } from "redux-actions";
import _assign from "lodash/assign";
import _find from "lodash/find";

import { MODAL_HIDE } from "./modal/actionTypes";

//  Actions
export const INTL_REGION_SET = "intl/INTL_REGION_SET";
export const INTL_CITY_SET = "intl/INTL_CITY_SET";

export const intlRegionAction = createAction(INTL_REGION_SET);
export const intlCityAction = createAction(INTL_CITY_SET);

//  Reducer
const serverState = window.initialState;

const initialState = _assign(
  {
    cities: [],
    cityId: 1,
    regionId: 2,
    countryId: 764,
  },
  serverState.intl
);

export default handleActions(
  {
    [INTL_REGION_SET]: applyRegion,
    [INTL_CITY_SET]: applyCity,
    [MODAL_HIDE]: applyReset,
  },
  initialState
);

//  Action Reducers
function applyRegion(state, { payload }) {
  return {
    ...state,
    regionId: payload,
    cityId: null,
    countryId: null,
  };
}

function applyCity(state, { payload }) {
  const { cityId, countryId } = payload;

  return {
    ...state,
    cityId,
    countryId,
  };
}

function applyReset() {
  return initialState;
}
